import React from 'react';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { searchActions } from '../../store/searchStore';
import { isIE } from '../common/utils';
import { PdfExportButton } from '../common/refButtons';
import Paging from '../common/pagingComponent';
import MainHeader from './mainHeader';
import SimpleSearchStats from '../common/simpleSearchStats';
import BbCheckbox from "../styling/bbCheckbox";

import './headersCommon.scss'

class BankcruptcySearchHeader extends React.Component {
    render() {
        const isOnSearchpage = this.endsWith(this.props.location.pathname, '/bankruptcy');
        const isOnResultsPage = this.endsWith(this.props.location.pathname, '/results');

        return (<>
            <MainHeader label="Search.Bankruptcy.SectionNameSPZ" {...this.props} />
            { !this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', { 'tinted': this.props.tinted })}>
                <ul style={{ border: "none" }}>
                    <li className={`tab-link ${isOnSearchpage ? 'is-active' : ''}`}>
                        <NavLink to={{ pathname: `${this.props.match.url}`, state: this.props.location.state }}>
                            <Translate id='Search.Common.Search' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnSearchpage ? "" : "none" }}></div>
                    </li>
                    <li className={`tab-link ${isOnResultsPage ? 'is-active' : ''}`}>
                        <NavLink to={`${this.props.match.url}/results`}>
                            <Translate id='Search.Common.Results' />
                        </NavLink>
                        <div className="search-progress-short" style={{ display: isOnResultsPage ? "" : "none" }}></div>
                    </li>
                </ul>
                {isOnResultsPage && this.renderPdfExport()}
            </div>}
            {!this.props.isMobile && isOnResultsPage && this.renderSearchManager()}
        </>)
    }

    endsWith = (str, suffix) =>
        isNullOrUndefined(str) || isNullOrUndefined(suffix) ? false : str.lastIndexOf(suffix, str.length - suffix.length) === str.length - suffix.length;

    renderSearchManager = () => {
        if (isNullOrUndefined(this.props.search) || isNullOrUndefined(this.props.search.searchResult))
            return null;

        const data = { ...this.props.search.searchResult.data };
        const currentPage = this.props.search.searchParams.page;
        const totalPages = isNullOrUndefined(data.found) ? 1 : Math.ceil(data.found / this.props.search.searchPaging.count);

        return (
            <div
                className={classnames(
                    "search-results-manager-wrapper",
                    { "relative": isIE() && !this.props.layout.scrolled, "fixed": isIE() && this.props.layout.scrolled, "tinted": this.props.tinted }
                )}
                style={((!isIE() || this.props.layout.scrolled) ? { top: `${this.props.layout.topMenuHeight}` } : {})}
            >
                <div className={classnames("search-results-manager", { "tinted": this.props.tinted })}>
                    <div className="result-counts-ordering-paging" style={{ justifyContent: "space-between", flexDirection: "row" }}>
                        <SimpleSearchStats foundCount={data.found} totalCount={data.total} page={currentPage} totalPages={totalPages} dbInfo={true} />
                        {totalPages > 1 && <>
                            <div className='result-paging hide-on-mobile'>
                                <Paging selectedPage={currentPage} totalPages={totalPages} setPage={(page) => this.props.changePageBankruptcy(page)} />
                            </div>
                        </>}
                        <div className="bb-chk-pdf-export">
                            <BbCheckbox name="pdf-all" label={this.props.translate("Common.Button.ExportPdf.SelectAllOnPage")} id="pdf_all"
                                value={this.allOnPageSelected()}
                                onChange={(v) => v ? this.props.addIdsToPdfExport(this.props.search.searchResult.data.items.map(item => item.id)) : this.props.removeIdsFromPdfExport(this.props.search.searchResult.data.items.map(item => item.id)) } />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderPdfExport = () => {
        const data = (isNullOrUndefined(this.props.search) || isNullOrUndefined(this.props.search.searchResult)) ? null : this.props.search.searchResult.data;

        if (isNullOrUndefined(data) || isNullOrUndefined(data.items) || data.items.length === 0)
            return null;

        return (
            <div className='search-pdf-export'>
                <div className='references print-hidden'>
                    <div className="ref-buttons" style={{ display: 'flex' }}>
                        <PdfExportButton onClick={() => this.props.exportBankruptciesSearchPdf()} />
                    </div>
                </div>
            </div>);
    }

    allOnPageSelected = () => {
        if (!isNullOrUndefined(this.props.search.searchResult.data)) {
            let items = this.props.search.searchResult.data.items;
            let ids = this.props.search.exportSettings.ids;
            if (items && ids && ids.length > 0 && items.length > 0) {
                for(var i = 0; i < items.length; i++)
                    if (!ids.includes(items[i].id))
                        return false;
                return true;
            } else
                return false;
        }
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search }, layout: { ...state.layout } }),
    dispatch => bindActionCreators(searchActions, dispatch)
)(BankcruptcySearchHeader)));